import { render, staticRenderFns } from "./StockIQProducts.vue?vue&type=template&id=7c63ca74"
import script from "./StockIQProducts.vue?vue&type=script&lang=js"
export * from "./StockIQProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports